import { HttpService } from "@/core";
export class WorkProgressService {
  // 施工计划明细详情列表
  static usePanelProgressListApi() {
    const api = (id: string,params={},isByProject=false) =>
      HttpService.axios({
        method: "GET",
        url: !isByProject?`/project_work_plan/${id}/ganttChart`:`/project_work_plan/${id}/ganttChartByProjectId`,
        params
      });
    return HttpService.useRequest<any>(api);
  }
}
